export default __webpack_public_path__ + "f452689a60c320c9558fa14bc09e4d9f.png";